module.exports = __webpack_public_path__ + "static/media/brl_note_50.b9fdb43a.jpg";